// extracted by mini-css-extract-plugin
export default {"table":"individualPreferences_table__AQIjl","tbody":"individualPreferences_tbody__IMJP1","tr":"individualPreferences_tr__8+-qf"};